import { apiService } from "./apiService";

interface WishlistItem {
  _id: string;
  product: {
    _id: string;
    name: string;
    price: number;
    images: string[];
    // Add other product fields as needed
  };
  createdAt: string;
  updatedAt: string;
}

export const wishlistApi = {
  /**
   * Get user's wishlist
   * @returns {Promise<WishlistItem[]>} Array of wishlist items
   */
  getWishlist: async (): Promise<WishlistItem[]> => {
    try {
      const response: any = await apiService.get("/wishlist");
      console.log("Raw wishlist response:", response);

      return response.data || []; // ✅ access actual items from backend response
    } catch (error: any) {
      console.error("Error fetching wishlist:", error);
      throw new Error(
        error.response?.data?.message || "Failed to fetch wishlist",
      );
    }
  },

  addToWishlist: async (productId: string): Promise<WishlistItem> => {
    try {
      const response: any = await apiService.post(
        "/wishlist/add",
        { productId },
      );
      return response.data;
    } catch (error: any) {
      console.error("Error adding to wishlist:", error);
      throw new Error(
        error.response?.data?.message || "Failed to add to wishlist",
      );
    }
  },
  // Remove a product from wishlist
  removeFromWishlist: async (productId: string) => {
    try {
      return await apiService.delete(`/wishlist/remove/${productId}`);
    } catch (error) {
      throw error;
    }
  },
  getWishlistCount: async (): Promise<{ count: number }> => {
    try {
      const response: any = await apiService.get("/wishlist/count");
      return response.data;
    } catch (error: any) {
      console.error("Error getting wishlist count:", error);
      throw new Error(
        error.response?.data?.message || "Failed to get wishlist count",
      );
    }
  },
  clearWishlist: async (): Promise<{ message: string }> => {
    try {
      const response: any = await apiService.delete("/wishlist/clear");
      return response.data;
    } catch (error: any) {
      console.error("Error clearing wishlist:", error);
      throw new Error(
        error.response?.data?.message || "Failed to clear wishlist",
      );
    }
  },
  checkWishlistStatus: async (
    productId: string,
  ): Promise<{ isInWishlist: boolean }> => {
    try {
      const response: any = await apiService.get(`/wishlist/check/${productId}`);
      return response.data;
    } catch (error: any) {
      console.error("Error checking wishlist status:", error);
      throw new Error(
        error.response?.data?.message || "Failed to check wishlist status",
      );
    }
  },
  moveToCart: async (
    productId: string,
    quantity: number = 1,
  ): Promise<{
    message: string;
    cartItem: {
      product: string;
      quantity: number;
      price: number;
    };
  }> => {
    try {
      const response: any = await apiService.post(
        `/wishlist/move-to-cart/${productId}`,
        { quantity },
      );
      return response.data;
    } catch (error: any) {
      console.error("Error moving item to cart:", error);
      throw new Error(
        error.response?.data?.message || "Failed to move item to cart",
      );
    }
  },
};
